<template>
  <div class="md-layout">
    <div class="md-layout-item">
      <!-- TODO 1: Loading State Handler -->
      <div v-if="isClientsLoading"><LoadingData /></div>

      <!--  TODO 2: Data Handler -->
      <div v-else>
        <!--  TODO 2.1:  Empty Data Handler -->
        <div v-if="isClientsEmpty">
          <EmptyData emptyText="You have not created any API credential" />
          <md-button class="md-primary" @click="createClient()"
            >Create API Credentials</md-button
          >
        </div>

        <!--  TODO 2.2: Data Exist Handler -->
        <div v-else>
          <!-- <div class="md-layout">
            <div class="md-layout-item md-small-size-100 md-size-25">
              <SwitchEnvironment @toggleEnvironment="toggleEnvironment"/>
            </div>
          </div> -->

            <!-- <Environment :client="client"/> -->
            <Environment :client="displayClient"/>
        </div>
      </div>
    </div>
    <md-snackbar
      md-position="center"
      :md-duration="6000"
      :md-active.sync="snackBar.show"
      md-persistent
    >
      <span>{{ snackBar.message }}</span>
    </md-snackbar>
  </div>
</template>

<script>
// import axios from "axios";
import http from '../../../utils/Http.util';
import EmptyData from '../../../components/EmptyData.vue';
import LoadingData from '../../../components/LoadingData.vue';
import Environment from './Environment.vue';
// import SwitchEnvironment from './SwitchEnvironment.vue';

export default {
  components: {
    EmptyData,
    LoadingData,
    Environment,
    // SwitchEnvironment,
  },
  created() {
    this.loadClients();
  },
  computed: {
    isLive() {
      return this.$store.state.isLive;
    },
    isClientsEmpty() {
      return !this.clients.length;
    },
    isStagingHost() {
      const { hostname } = window.location;
      return hostname === 'localhost' || hostname === 'xdashboard.buypower.ng';
    },
    displayClient() {
      return this.isStagingHost ? this.environment.test : this.environment.production;
    },
  },

  data() {
    return {
      clients: [],
      isClientsLoading: false,
      environment: { test: {}, production: {} },
      snackBar: {
        show: false,
        message: null,
      },
    };
  },
  methods: {
    getEnvironments() {
      if (this.clients.length) {
        this.clients.forEach((client) => {
          if (client.type === 'test') {
            this.environment.test = {
              type: client.type,
              url: 'https://idev.buypower.ng/v2',
              apiKey: client.token,
              title: 'Test Environment',
            };
          } else if (client.type === 'production') {
            this.environment.production = {
              type: client.type,
              url: 'https://api.buypower.ng/v2',
              apiKey: client.token,
              title: 'Production Environment',
            };
          }
        });
      }
    },
    async loadClients() {
      this.isClientsLoading = true;
      try {
        const { data, message } = await http.authReq('/dashboard/clients');
        this.clients = data;
        this.getEnvironments();
        this.isClientsLoading = false;
        if (this.clients.length) {
          this.snackBar = {
            show: true,
            message,
          };
        }
      } catch (error) {
        this.snackBar = {
          show: true,
          message: error.response ? error.response.data.message : error.message,
        };
        this.isClientsLoading = false;
      }
    },
    async createClient() {
      this.isCreateLoading = true;
      this.$store.commit('busyStatus', true);
      try {
        const { message } = await http.authReq(
          '/dashboard/clients',
          {},
          'post',
        );
        this.loadClients();
        this.snackBar = {
          show: true,
          message,
        };
        this.isCreateLoading = false;
        this.$store.commit('busyStatus', false);
      } catch (error) {
        this.snackBar = {
          show: true,
          message: error.response ? error.response.data.message : error.message,
        };
        this.isCreateLoading = false;
        this.$store.commit('busyStatus', false);
      }
    },
  },
};
</script>
